import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { string, array, bool, object } from "prop-types";

import { getExcerpt } from "../../utils/utils";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../SponsorDetails";
import Excerpt from "../../atoms/Excerpt";
import SectionHolder from "../../atoms/SectionHolder";

import "./newsWithImage.m.css";

const NewsWithImage = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  showDot = false,
  styles = {},
  showSubHeading = true,
  showExcerpt = false,
  cssStyleName = "",
}) => {
  const excerpt = showExcerpt && getExcerpt(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  return (
    <div styleName="news_with_item" className="news_with_item">
      {showHeroImage && (
        <Link aria-label={story.headline} href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            showAlternateImage={true}
          />
        </Link>
      )}
      {showLiveBlog ? (
        <LiveNewsHeadline story={story} cssStyleName={cssStyleName} showDot={showDot} styles={styles} />
      ) : (
        <NewsHeadline
          story={story}
          cssStyleName={cssStyleName}
          showDot={showDot}
          styles={styles}
          showSubHeading={showSubHeading}
        />
      )}

      {showExcerpt && <Excerpt excerpt={excerpt} excerptLink={story.url} />}
      {sponsorId && !showLiveBlog ? (
        <SponsorDetails sponsorId={sponsorId} showImage={false} />
      ) : (
        <SectionHolder story={story} />
      )}
    </div>
  );
};

NewsWithImage.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  showExcerpt: bool,
  cssStyleName: string,
};

export default NewsWithImage;
